import { type AssignmentJobRejectionResponseType } from './AssignmentJobRejectionApi';
import { type AssignmentJobResponseType } from './AssignmentJobApi';
import type { JobResponseType, JobServiceAttributesType } from '../Jobs/types';
import { Job } from '../Jobs/Job';

export class AssignmentJobRejection {

    public assignmentJobRejection: AssignmentJobRejectionResponseType;

    constructor(assignmentJobRejection: AssignmentJobRejectionResponseType) {
        if (assignmentJobRejection.job && !assignmentJobRejection.job.rejected) {
            assignmentJobRejection.job.rejected = true;
        }
        this.assignmentJobRejection = assignmentJobRejection;
    }

    public getAsAssignmentJob(): AssignmentJobResponseType {
        return {
            id: 0,
            job_id: this.assignmentJobRejection.job_id,
            assignment_id: this.assignmentJobRejection.assignment_id,
            job: this.assignmentJobRejection.job,
            details: {
                service_attributes: this.assignmentJobRejection.driver_info?.service_attributes
            }
        }
    }

    public setServiceAttributes(serviceAttributes: JobServiceAttributesType | undefined) {
        this.assignmentJobRejection.driver_info.service_attributes = serviceAttributes;
    }

}